export var WebsiteRedirectSourceTypeEnum;

(function (WebsiteRedirectSourceTypeEnum) {
  WebsiteRedirectSourceTypeEnum["landingPage"] = "landingPage";
})(WebsiteRedirectSourceTypeEnum || (WebsiteRedirectSourceTypeEnum = {}));